<template>
    <div class="section">
        <div class="anchor" id="schedule"></div>
        <img class="title" src="@/assets/images/title_03.png" alt="">
        <div class="sec-box sec-schedule" id="sec-schedule">
            <div class="box-route">
                <div class="tab">
                    <ul>
                        <li :key="index" v-for="(item, index) in calendarData" :class="{ on : tab === (item.id - 1) }" @click="clickTab(item.id - 1)">
                            <p>DAY {{ item.id }}</p>
                            <span>{{ item.day }}</span>
                        </li>
                    </ul>
                </div>

                <div class="route">
                    <ul>
                        <li v-for="(item, index) in calendarData[tab].routes" :key="index">
                            <router-link :to="`/schedule/${ item.id }`">
                                <div class="time">{{ item.time }}</div>
                                <div class="info">
                                    <div class="avatar"><img v-if="item.cover" :src="require(`@/assets/images/${ item.cover }`)" alt="" /></div>
                                    <div class="intro">
                                        <p>{{ item.title }}</p>
                                        <span v-html="item.artist"></span>
                                    </div>
                                </div>
                                <i class="remixicon-arrow-right-line"></i>
                            </router-link>
                        </li>
                        
                    </ul>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import calendarData from '@/data/calendar.js'

export default {
    name: 'SecSchedule',
    data() {
        return {
            tab: 0,
            calendarData: [],
        }
    },
    methods: {
        clickTab(idx) {
            this.tab = idx
        }
    },
    computed: {
    },
    created() {
        this.calendarData = calendarData
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/components/variable";

.home>div.section {
    margin-top: 140px;
}

.section {
    .title {
        margin-top: 15%;
    }
}

.sec-schedule {
    // width: 650px;
    // max-width: 100%;
    display: flex;
    justify-content: center;
    color: #fff;

    .title {
        margin: 180px 0 0 60px;
    }
}

.box-route {
    width: 640px;
    flex-shrink: 0;
    margin-left: 300px;
}

.tab {
    position: relative;
    border-bottom: 1px solid #333;

    ul {
        display: flex;
        justify-content: space-between;

        li {
            flex-grow: 1;
            color: #666;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 0;
            cursor: pointer;
            font-family: 'GT America Y Compressed';

            p {
                font-size: 28px;
            }

            span {
                font-size: 18px;
                margin-top: 8px;
            }

            &.on {
                color: #fff;
                position: relative;

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 5px;
                    background-color: $purple;
                    position: absolute;
                    bottom: -2.5px;
                    left: 0;
                }
            }
        }
    }
}

.time {
    font-size: 14px;
    margin-right: 75px;
}

.info {
    display: flex;
    align-items: center;
    flex-grow: 1;

    .avatar {
        margin-right: 20px;
    }
}

.intro {
    p {
        font-size: 18px;
    }

    span {
        display: block;
        font-size: 14px;
        margin-top: 12px;
        color: #888;
    }
}

.route {
    width: 100%;
    overflow-y: scroll;
    height: 495px;
    box-sizing: border-box;

    ul {
        li {
            a {
                display: flex;
                align-items: center;
                padding: 25px 0;
                border-bottom: 1px dotted #333;
            }

            i {
                margin-left: 55px;
                font-size: 22px;
            }
        }
    }
}



@media all and (max-width: 1024px) {

.sec-schedule {
    display: flex;
    flex-direction: column;
}

.box-route {
    max-width: 92%;
    // height: 360px;
    margin: 0 auto;
}



.route {
    height: 400px;

    ul li {
        a {
            flex-wrap: wrap;
            padding: 5% 0;
        }

        i {
            margin-left: 10px;
        }
    }
}

.info .avatar {
    margin-right: 10px;
}

.time {
    margin-right: 10px;
    // width: 100%;
}


}


@media all and (max-width: 768px) {

.tab ul li {
    p {
        font-size: 5vw;
    }

    span {
        font-size: 3.4vw;
    }
}

.intro {
    p {
        font-size: 4vw;
    }

    span {
        font-size: 3.2vw;
    }
}

.notice {
    margin-top: 6%;
}

.time {
    width: 100%;
    margin-bottom: 3%;
}

}
</style>